export default __webpack_public_path__ + "static/media/TALINTO_LOGO.fb982df0.png";